const ALLOWED_PATTERN = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ®0-9\s@.,_\-/#']+$/;

export const containsDangerousChars = (value: string): boolean => {
  return !ALLOWED_PATTERN.test(value);
};

export const isOnlyWhitespace = (value: string): boolean => {
  return value.trim().length === 0;
};

export const sanitizeRule = (message: string, whitespaceMessage?: string) => ({
  validator: (_: any, value: string) => {
    if (value && isOnlyWhitespace(value)) {
      return Promise.reject(whitespaceMessage || message);
    }
    if (value && containsDangerousChars(value)) {
      return Promise.reject(message);
    }
    return Promise.resolve();
  },
});

export const httpsUrlRule = (message: string) => ({
  validator: (_: any, value: string) => {
    if (!value) return Promise.resolve();
    try {
      const parsed = new URL(value);
      if (parsed.protocol !== 'https:') return Promise.reject(message);
      return Promise.resolve();
    } catch {
      return Promise.reject(message);
    }
  },
});